import React, { useContext, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useHttp } from '../../../../hooks/http.hook';
import { useMessageError, useMessageSuccess } from '../../../../hooks/message.hook';
import { useNavigate } from 'react-router-dom';
import BrandForm from '../../../../components/Forms/BrandForm/BrandForm'; // Assuming BrandForm is a separate component
import axios from 'axios';
import { AuthContext } from '../../../../context/AuthContext';

const FormWrapper = ({ edit, create, id, close}) => {
    const { request } = useHttp();
    const auth = useContext(AuthContext);
    const messageError = useMessageError();
    const messageSuccess = useMessageSuccess();
    const navigator = useNavigate();
    const [initialValues, setInitialValues] = useState({
        name: "",
        imageUrl: "",
        active: false
    });

    const getById = async () => {
        try {
            const data = await request(`admin/brands/get/${id}`, "GET");
            setInitialValues(data.data);
            messageSuccess(data.message);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        if (edit) getById();
    }, [edit]);

    const onSubmit = async (values) => {
        try {
            const config = {}
            if(auth.isAuthenticated){
                config.headers = {"Authorization": `Bearer ${auth.token}`}
            }
            if (create) {
                const data = await axios.post(`/api/admin/brands/create`, values, config)
                .then(res => {messageSuccess(res.data.message);})
                .catch(er => messageError(er.response.data.message))
                close(true);
            }

            if (edit) {
                const data = await axios.put(`/api/admin/brands/edit/${id}`, values, config)
                .then(res => {messageSuccess(res.data.message);})
                .catch(er => messageError(er.response.data.message))
                close(true);
            }
        } catch (e) {
            messageError(e);
        }
    };

    return (
        <div>
            <BrandForm initialValues={initialValues} onSubmit={onSubmit} edit={edit}/>
        </div>
    );
};

export default FormWrapper;
